import type { FaireProductEntity } from "../../entity_types/product";

export const p_j74syj6gtv: FaireProductEntity = {
  token: "p_j74syj6gtv",
  type: "product",
  name: "SCALLOPED DENIM SHORTS",
  brandToken: "b_2a388unpqo",
  brandName: "Bluivy",
  imageUrl: "https://cdn.faire.com/fastly/ba5de0978564fedf7d9b4c9f0e2b184f4c63b0bed4f14844f71a282524dafd46.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5a75f95a4f31e6cb00a77631be9bce2d773a3225132911b26968bb4fcb0e43f2.jpeg",
    "https://cdn.faire.com/fastly/8f6cf28f8e9d26a7fe2f53738dc246ba92c990649db00c1188762ee24e65ac81.jpeg",
    "https://cdn.faire.com/fastly/133328fdda0f4ff1c23cd7a7ba531889363b0b155c95236ab387a0965d7afe18.jpeg",
    "https://cdn.faire.com/fastly/e0d388632d35a08d5b867e65e56ee897099a37bd03b29e09a530562553e1da07.jpeg",
    "https://cdn.faire.com/fastly/9a24266d1b8e0b679c6fb62c9de2f4fc9311dc56acbd692e0e885e44e07ccc88.jpeg",
    "https://cdn.faire.com/fastly/65137587a1d11d0ce5f9543f0fb023b66a3c9f46cb3136234c590da0486dfce3.jpeg",
    "https://cdn.faire.com/fastly/52cfe7d148b04f309307ba4ead83da52f2c4448b42e42d37bd2f8647ec804e2c.jpeg",
    "https://cdn.faire.com/fastly/c5be0dbfd298d7de814f9f082bb2c5c409885244fe2a0f47089964f9ad7b588e.jpeg",
    "https://cdn.faire.com/fastly/cbcc4a9d71307e602185546caae291fbddd939167d7dbb5384933c3cc3e0c9bd.jpeg",
    "https://cdn.faire.com/fastly/181635cb6585ba9fc40965662f6b068319ef7005fc42d6f1c1a9ad42082cd923.jpeg",
    "https://cdn.faire.com/fastly/8a9d7ddd74b76bec52cd123ad8f7202b2e84f4d803826d83aceabbb34515996a.jpeg",
    "https://cdn.faire.com/fastly/3df70be14c634a4649ef9b87124df5b7cf23b05b7240f5fe8250290f52e59478.jpeg",
    "https://cdn.faire.com/fastly/5587ebd84ba2dbf337739874f99c088975e3f19e7f061a9c53b16d7d621d77c7.jpeg",
    "https://cdn.faire.com/fastly/48b2a18e360d50dce962f70ee91c201fd6af31fb80f6ff10e069c8998758316d.jpeg",
    "https://cdn.faire.com/fastly/d8fac6fd4966a3bfc8f45d041b91351c5add16a0ef84716db658a7eed1677155.jpeg",
    "https://cdn.faire.com/fastly/f7a1351471d8d3f321f1d3d4539b8aed82132f4f3afecb70e21abccbfb9a8caf.jpeg",
    "https://cdn.faire.com/fastly/53afd64d78594636c3cdfc9aea783098acde2f4eb4e4660a2f9de0f621e220e8.jpeg",
    "https://cdn.faire.com/fastly/88dbdcc76231a51386cecda3368d8a06d011e9e113cb28a369220deedb6f2bed.jpeg"
  ],
  priceDollars: 138,
  description: "Give your denim collection a playful upgrade with our Scalloped Hem Shorts. Featuring a unique, curved laser-cut hemline, these shorts bring a romantic \"coquette\" touch to a rugged classic. Crafted from premium non-stretch denim in a vintage-inspired light indigo wash, they feature a flattering high-rise waist and a relaxed leg for all-day comfort. Finished with a traditional five-pocket design and a polished silver button closure, these are the perfect pair for festivals, beach days, and everything in between.\n\n-Design: Classic five-pocket denim shorts with a standout scalloped hemline.\n-Fit: Flattering high-rise waist with a relaxed leg opening.\n-Color: Vintage Light  and Medium Wash Blue with subtle fading.\n-Closure: Button and zip-fly closure with silver-tone hardware.\n-Fabric: Authentic, durable denim with a soft, lived-in feel.\n-Size: Model is 5'9\" and wearing a Small.",
  tags: [],
  msrpDollars: 276,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:03:34.212Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
